<template>
  <div>
    <tr
      class="ivu-table-row"
    >
      <td
        :style="{ width: `${chart.width}px`, minWidth: `${chart.width}px`, maxWidth: `${chart.width}px` }"
        class="ivu-table-column-center"
      >
        <div
          v-if="chart.type === 'line'"
          :style="{ width: `${chart.width}px`, height: '28px' }"
          class="ivu-table-cell custom-table-line-chart"
        >
          <LineChart
            :data="computeLineChartData(data, chart.xAxis)"
            :margin="{ l: 0, r: 0, t: 0, b: 0 }"
            hide-toolbar
            style="height:100%;width:100%"
          />
        </div>
      </td>
    </tr>
    <template v-if="column.children">
      <template v-for="(childrenColumn, index) in Object.keys(column.children)">
        <CustomTableTrFixedChart
          v-if="column._childrenExpand"
          :key="`custom-table-fixed-body-tr-${depth}-${index}`"
          :column="Object.assign(column.children[childrenColumn], { name: childrenColumn })"
          :data="data"
          :chart="chart"
          :header-column="headerColumn"
          :depth="depth + 1"
        />
      </template>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import LineChart from '@/components/helper-components/chart-components/LineChart'
import CustomTableUtilMixin from '@/mixins/custom-table-util-mixin'

export default {
  name: 'CustomTableTrFixedChart',

  components: {
    LineChart
  },

  mixins: [ CustomTableUtilMixin ],

  props: {
    column: {
      type: Object,
      default: () => {}
    },

    data: {
      type: Array,
      default: () => []
    },

    chart: {
      type: Object,
      default: () => {}
    },

    headerColumn: {
      type: Object,
      default: () => {}
    },

    depth: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      numberTypes: ['number', 'decimal', 'percentage', 'currency', 'currencyDecimal'],
      dateTypes: ['date']
    }
  },

  methods: {
    /**
     * Compute Line Chart data for display
     * @param {Array}  dataset
     * @param {String} xColumn
     * @return {Array} line chart data for column
     */
    computeLineChartData (dataset, xColumn) {
      if (!dataset.length) {
        return { x: [], y: [] }
      }

      const chartData = {
        x: dataset.map(row => row[xColumn]),
        y: dataset.map(row => row[this.column.name]),
        text: dataset.map(row => {
          const xValueToFormat = this.headerColumn.chartFormat || this.headerColumn.toFormat
          const formattedXValue = this.formatCellByPath(row, [this.headerColumn.name], this.headerColumn.format, this.headerColumn.fromFormat, xValueToFormat)
          const formattedYValue = this.formatCellByPath(row, [this.column.name], this.column.format, this.column.fromFormat, this.column.toFormat)

          return `${formattedXValue}: ${formattedYValue}`
        })
      }

      /** TODO move pop logic into dashboard to make it more general
       * Right now charting is only used in metrics summary. To show a good and accurate trend, the current period data will be removed from data
       * since it's not done and accurate
       */
      chartData.x.pop()
      chartData.y.pop()
      chartData.text.pop()

      return chartData
    },

    /**
     * Format cell based on path and format
     * @param {Object} row to find value based on path
     * @param {Array} path The path of the property to get.
     * @param {String} format
     * @param {String} fromFormat Original date format
     * @param {String} toFormat Transformed date format
     * @param {Number} precision Precision for number casting
     * @return {Number|Date|String} return formatted value based on types
     */
    formatCellByPath (row, path, format, fromFormat, toFormat, precision) {
      if (this.numberTypes.includes(format)) {
        return this.formatNumber(_.get(row, path, ''), format, precision)
      } else if (this.dateTypes.includes(format)) {
        return this.$moment(_.get(row, path, new Date()), fromFormat).format(toFormat)
      } else {
        return _.get(row, path, '')
      }
    }
  }
}
</script>

<style scoped>
  .ivu-table-small td {
    height: 30px;
  }

  .ivu-table-cell {
    padding: 3px 5px;
    word-break: unset;
  }

  .custom-table-line-chart >>> .js-plotly-plot .plotly .cursor-crosshair {
    cursor: pointer;
  }
</style>
